import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

export const AvgBuyMcDistributionTrackSkeleton = () => {
  return (
    <Track>
      <Fill height="50%" />
    </Track>
  )
}

const Track = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: var(--appearanceA-5, var(--appearanceA-5));
`
const Fill = styled(Skeleton)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  > * {
    border-radius: 0;
  }
`
